import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { YodiMark } from "@/components/brand/YodiMark";
import { useApp } from "@/hooks/use-app-context";
import { visitorHeaderText } from "./visitor-header-copy";

/**
 * Frame of the public website header (visitors, and staff browsing the site):
 * the same flat bar as the contributor header, logo on the left, links in the
 * middle, actions on the right.
 */
export function SiteHeaderBar({ lang, nav, actions }: { lang: string; nav?: ReactNode; actions: ReactNode }) {
  const { language } = useApp();
  return (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-background/95 backdrop-blur">
      <div className="container mx-auto flex h-16 items-center gap-4 px-4 sm:px-6">
        <Link
          to={`/${lang}`}
          className="flex shrink-0 items-center gap-2.5 rounded-lg focus-ring"
          aria-label={visitorHeaderText(language).home}
        >
          <YodiMark className="size-9 rounded-lg" />
          <span className="hidden whitespace-nowrap text-base font-semibold tracking-tight text-foreground sm:inline">
            Yodi <span className="text-muted-foreground">Data Hub</span>
          </span>
        </Link>

        <div className="flex min-w-0 flex-1 justify-center">{nav}</div>

        <div className="flex shrink-0 items-center gap-1 sm:gap-1.5">{actions}</div>
      </div>
    </header>
  );
}
